import React from "react";

const clampProgress = (value) => Math.max(0, Math.min(100, Number(value || 0)));

const KpiCard = ({
  title,
  value,
  subtitle,
  color = "primary",
  icon,
  loading,
  progress = 0,
  progressLabel,
  footnote,
  featured = false,
  comparison,
  onClick,
  columnClassName = "col-6 col-xl-3",
}) => (
  <div className={columnClassName}>
    <div className={`card h-100 akas-summary-card dashboard-card dashboard-kpi-card dashboard-accent-${color} ${featured ? "is-featured" : ""}`}>
      <div className="card-body dashboard-kpi-card-body">
        <div className="dashboard-kpi-content">
          <div className="d-flex align-items-start justify-content-between gap-3">
            <div className="dashboard-kpi-title text-secondary">{title}</div>
            <span className={`dashboard-kpi-icon bg-${color}-lt text-${color}`}>{icon}</span>
          </div>
          {loading ? (
            <div className="placeholder placeholder-lg w-50 dashboard-kpi-placeholder"></div>
          ) : (
            <div className="dashboard-kpi-value mb-0">{value}</div>
          )}
          {subtitle ? <div className="dashboard-kpi-subtitle text-secondary">{subtitle}</div> : null}
          {loading ? null : comparison ? (
            <div className="dashboard-kpi-comparison" title={comparison.description}>
              <span className={`text-${comparison.tone}`}>{comparison.label}</span>
              <span className="text-secondary">vs sebelumnya</span>
            </div>
          ) : progressLabel ? (
            <div className="dashboard-kpi-progress-wrap">
              <div className="d-flex justify-content-between align-items-center mb-1">
                <span className="dashboard-kpi-progress-label text-secondary">{progressLabel}</span>
                <span className={`dashboard-kpi-progress-value text-${color}`}>{clampProgress(progress).toFixed(0)}%</span>
              </div>
              <div className="progress dashboard-kpi-progress">
                <div
                  className={`progress-bar bg-${color}`}
                  style={{ width: `${clampProgress(progress)}%` }}
                  role="progressbar"
                  aria-valuenow={clampProgress(progress)}
                  aria-valuemin="0"
                  aria-valuemax="100"></div>
              </div>
            </div>
          ) : (
            <div className="dashboard-kpi-footnote text-secondary">{footnote || "Periode yang dipilih"}</div>
          )}
        </div>
        {onClick ? (
          <button type="button" className="dashboard-kpi-trigger" onClick={onClick} disabled={loading} title={comparison?.description || footnote} aria-label={`Lihat rincian ${title}`}>
            <span aria-hidden="true">↗</span>
          </button>
        ) : null}
      </div>
    </div>
  </div>
);

export default KpiCard;
